import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import "./index.css";

export default ({ station, getStationId }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const arr = station.map((item) => {
      return {
        label: item.aliasName || item.name,
        key: item.id,
      };
    });
    setItems(arr);
  }, [station]);

  return (
    <div>
      <Tabs
        onChange={(e) => getStationId && getStationId(e)}
        items={items}
        style={{ height: 220 }}
      ></Tabs>
    </div>
  );
};
